import React, { useEffect } from 'react'
import List from './List'
import { useCardContext } from '../../../../../../components/Card/CardContext'
import { useCandidateDetailsById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const candidate = useCandidateDetailsById(id)
  const cardContext = useCardContext()
  const name = [candidate?.name?.last, candidate?.name?.first].filter(v => typeof v === 'string').join(', ')
  useEffect(() => {
    if (name !== undefined && name !== null) {
      cardContext.setTitle(`Candidate - ${name}`)
    } else {
      cardContext.setTitle('Candidate')
    }
  }, [name])
  return (
    <List candidate={candidate} />
  )
}

export default Body
